var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"text":"","icon":"","href":("mailto:" + _vm.email),"target":"_blank"}},[_c('v-icon',[_vm._v("mdi-at")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }